export default {
  SIGN_IN: 'auth/SIGN_IN',
  SIGN_IN_SUCCESS: 'auth/SIGN_IN_SUCCESS',
  SIGN_IN_FAILURE: 'auth/SIGN_IN_FAILURE',
  SIGN_OUT: 'auth/SIGN_OUT',
};
